export default __webpack_public_path__ + "static/media/modal-img.5ce93c90.svg";